let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5gGJt")).then(() => parcelRequire('96DZB'));